module.exports = __webpack_public_path__ + "static/media/badge_support_2.6f9671c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_support_2.png
// module id = 508
// module chunks = 0